import { defineMessages } from '@jutro/locale';

export default defineMessages({
    continue: {
        id: 'ml.gateway.MLVoidPaymentPopup.Continue',
        defaultMessage: 'Continue'
    },
    cancel: {
        id: 'ml.gateway.MLVoidPaymentPopup.Cancel',
        defaultMessage: 'Cancel'
    },
    voidingThisTransaction: {
        id: 'ml.gateway.MLVoidPaymentPopup.Voiding this transaction when a payment is due could result in overdue payment or policy cancellation.',
        defaultMessage: 'Voiding this transaction when a payment is due could result in overdue payment or policy cancellation.'
    },
    wouldYouLikeToContinue: {
        id: 'ml.gateway.MLVoidPaymentPopup.Would you like to continue to void this transaction?',
        defaultMessage: 'Would you like to continue to void this transaction?'
    },
    bundlePaymentMessage: {
        id: 'ml.gateway.MLVoidPaymentPopup.Payment x applies to multiple policies. This will cancel the payment for all related policies.',
        defaultMessage: 'Payment {confirmationNumber} applies to multiple policies. This will cancel the payment for all related policies.'
    }
});
